module.exports = __webpack_public_path__ + "static/media/buz.7a2e0a79.jpg";